import { Control } from "react-hook-form";
import { FormInputNumber } from "../../../../components/ui/Input/FormInputNumber/FormInputNumber";
import { FormSelect } from "../../../../components/ui/Input/FormSelector/FormSelect";
import { energyPercentageRules, facilityNumberRules } from "../helpers/facilityValidation.helpers";
import { FacilityDraftFormValues, UnitOption } from "../types/facilityDrawer.types";
import FacilityYearInput from "./FacilityYearInput";

interface EnergyRecordFieldsProps {
  control: Control<FacilityDraftFormValues>;
  index: number;
  energyOptions: UnitOption[];
  distributionError?: string;
}

const EnergyRecordFields = ({ control, index, energyOptions, distributionError }: EnergyRecordFieldsProps) => (
  <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-5 tw-gap-4">
    <FormSelect
      control={control}
      name={`energy.${index}.EnergyType`}
      label="Source"
      required
      errorMessage="Source is required"
      options={energyOptions}
      placeholder="Select source"
    />
    <FacilityYearInput control={control} name={`energy.${index}.Year`} />
    <FormInputNumber
      control={control}
      name={`energy.${index}.kWhConsumed`}
      label="kWh consumed"
      rules={facilityNumberRules}
      rightContentEnable
      rightContent="kWh"
      enableLimitedDecimal
      viewDecimalNumber={5}
    />
    <div className="tw-space-y-1.5">
      <FormInputNumber
        control={control}
        name={`energy.${index}.Percentage`}
        label="Percentage distribution"
        required
        errorMessage="Percentage is required"
        rules={energyPercentageRules}
        rightContentEnable
        rightContent="%"
      />
      {distributionError && (
        <p className="tw-text-sm tw-font-medium tw-text-destructive">{distributionError}</p>
      )}
    </div>
    <FormInputNumber
      control={control}
      name={`energy.${index}.Price`}
      label="Price per kWh"
      rules={facilityNumberRules}
      enableLimitedDecimal
      viewDecimalNumber={5}
    />
  </div>
);

export default EnergyRecordFields;
